import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { orNull } from 'root/src/shared/util/ramdaPlus'
import { colorsNew } from 'root/src/client/web/commonStyles'
import classNames from 'classnames'
import { styledTwitchButton } from './style'

// eslint-disable-next-line max-len
const Button = memo(({
	title, subtitle, icon, className, onClick, iconSize, children, image, classes,
}) => (
	<button
		type="button"
		className={classNames(classes.button, className)}
		onClick={onClick}
	>
		{orNull(icon,
			<FontAwesomeIcon icon={icon} size={iconSize || 'lg'} color={colorsNew.dark2} />)}
		{orNull(image,
			<img src={image} alt="back" />)}
		<div>
			<div className={classes.buttonTitle}>{title}</div>
			<span className={classes.buttonSubtitle}>{subtitle}</span>
			{children}
		</div>
	</button>
))

Button.defaultProps = {
	subtitle: '',
}
export default withStyles(styledTwitchButton, { name: 'MuiSecondaryButton' })(Button)
